/**
 * User-facing scoring documentation. Keep in sync with formulas.js.
 * This module exists so UI can render "how we calculate" explanations
 * without importing the engine's numeric internals.
 *
 * @module lib/constants/scoring
 */

export const SCORING_RULES = Object.freeze({
  wordDefinition:
    '1 word = 5 characters. This is the standard used by Monkeytype, ' +
    '10fastfingers, and most competitive typing sites.',
  grossWpm:
    'Gross WPM = (all typed characters ÷ 5) ÷ elapsed minutes. ' +
    'Every keystroke counts, whether correct or not.',
  netWpm:
    'Net WPM = (correct characters ÷ 5) ÷ elapsed minutes. ' +
    'Mistakes lower the score because they do not contribute to the numerator.',
  accuracy:
    'Accuracy = (correct characters ÷ total typed characters) × 100. ' +
    'Backspace does not retroactively turn a mistake into a correct keystroke.',
  elapsed:
    'Elapsed time measures only active spans. Time spent on other tabs or ' +
    'while paused is excluded, so leaving a test open does not inflate WPM.',
  leaderboardEligibility:
    'Only attempts of at least 60 seconds with a positive net WPM and at least ' +
    'one correct character can enter the public leaderboard.',
  tieBreak:
    'Leaderboard ties are broken by higher accuracy, then by earlier submission.',
});